// Silvester-Rubbellos (sections/nye-scratch.liquid). Zieht beim Laden einen Gewinn nach
// Gewichtung, legt ihn unter eine Goldfolie (Canvas) und deckt ihn auf, sobald gut die Hälfte
// freigerubbelt ist. Danach Gewinn-Ansicht mit Code + Feuerwerk. Ansicht nach Datum
// (deutsche Zeit): vor dem Start, Los, vorbei. Vorschau: ?rubbellos=an / ?rubbellos=aus.
(function () {
  var REVEAL_AT = 0.5;
  var ICONS = {
    percent: '<circle cx="-7" cy="-7" r="5"/><circle cx="7" cy="7" r="5"/><path d="M10-11L-10 11" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>',
    truck: '<path d="M-14-8h17v14h-17zM3-3h7l5 5v4H3z"/><circle cx="-8" cy="9" r="3.4"/><circle cx="8" cy="9" r="3.4"/>',
    clover:
      '<circle cx="0" cy="-7" r="6"/><circle cx="7" cy="0" r="6"/><circle cx="0" cy="7" r="6"/><circle cx="-7" cy="0" r="6"/>' +
      '<path d="M1 4q4 7 10 11" stroke="currentColor" stroke-width="2.6" fill="none" stroke-linecap="round"/>',
    rocket: '<path d="M0-16c6 5 7 14 4 22H-4c-3-8-2-17 4-22z"/><path d="M-4 2l-6 7 6-1zM4 2l6 7-6-1z"/><path d="M-2 8h4l-2 8z" fill-opacity=".6"/>',
    glass: '<path d="M-7-15h14l-2 13a5 5 0 01-10 0z"/><path d="M-1 3h2v9h-2zM-6 13h12v2h-12z"/><circle cx="3" cy="-18" r="1.6"/><circle cx="7" cy="-21" r="1.2"/>',
    pig:
      '<ellipse cx="0" cy="2" rx="13" ry="10"/><path d="M-8-6l-3-6 6 3zM8-6l3-6-6 3z"/><ellipse cx="0" cy="4" rx="5" ry="3.6" fill="#0b1430" fill-opacity=".35"/>' +
      '<circle cx="-5" cy="-1" r="1.4" fill="#0b1430"/><circle cx="5" cy="-1" r="1.4" fill="#0b1430"/><path d="M-9 11v4M9 11v4" stroke="currentColor" stroke-width="3"/>',
    euro: '<path d="M11-12a14 14 0 100 24" stroke="currentColor" stroke-width="4.5" fill="none" stroke-linecap="round"/><path d="M-15-4h17M-15 4h15" stroke="currentColor" stroke-width="3.5" stroke-linecap="round"/>',
    jar: '<rect x="-14" y="-15" width="28" height="9" rx="3"/><path d="M-12-4h24v14a5 5 0 01-5 5h-14a5 5 0 01-5-5z"/><path d="M-6 3h12" stroke="#0b0b0d" stroke-opacity=".35" stroke-width="2.4" stroke-linecap="round"/>',
    dud: '<path d="M0-12c5 4 6 11 3 18H-3c-3-7-2-14 3-18z" transform="rotate(35)"/><path d="M8 8q4 4 2 8M12 4q5 2 6 6" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/>'
  };

  function init(root) {
    var prizes = [];
    try {
      prizes = JSON.parse(root.querySelector('[data-nye-prizes]').textContent) || [];
    } catch (e) {}
    var d = root.dataset;
    var dudOn = d.dud === 'true' && Number(d.dudWeight) > 0;
    var respin = d.respin === 'true';
    var storageKey = d.storageKey;

    showView(root, phase(d));
    if (!prizes.length) return;

    var card = root.querySelector('[data-nye-card]');
    var canvas = root.querySelector('[data-nye-foil]');
    var prizeIcon = root.querySelector('[data-nye-prize-icon]');
    var prizeTitle = root.querySelector('[data-nye-prize-title]');
    var revealLink = root.querySelector('[data-nye-reveal]');
    var ticketNo = root.querySelector('[data-nye-ticket-no]');
    var result = root.querySelector('[data-nye-result]');
    var redeem = result.querySelector('[data-nye-redeem]');
    var again = result.querySelector('[data-nye-again]');
    var ctx = canvas.getContext('2d');
    var current = -1;
    var revealed = false;
    var scratching = false;
    var last = null;
    var checkTimer = null;

    function newTicket(index) {
      current = index === undefined ? draw(prizes, dudOn ? Number(d.dudWeight) : 0) : index;
      revealed = false;
      var prize = prizes[current];
      card.classList.toggle('nye__card--dud', current < 0);
      prizeIcon.innerHTML = '<svg viewBox="-24 -24 48 48">' + ICONS[current < 0 ? 'dud' : prize.icon || 'clover'] + '</svg>';
      prizeTitle.textContent = current < 0 ? 'Niete' : prize.label || prize.title;
      ticketNo.textContent = 'Nr. ' + String(1000 + ((Math.random() * 9000) | 0));
      result.hidden = true;
      revealLink.hidden = false;
      paintFoil();
    }

    function paintFoil() {
      var rect = card.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.round(rect.width * dpr));
      canvas.height = Math.max(1, Math.round(rect.height * dpr));
      canvas.style.opacity = '1';
      canvas.style.display = '';
      var w = canvas.width;
      var h = canvas.height;
      ctx.globalCompositeOperation = 'source-over';
      var gold = ctx.createLinearGradient(0, 0, w, h);
      gold.addColorStop(0, '#b8892f');
      gold.addColorStop(0.3, '#f3dc8e');
      gold.addColorStop(0.55, '#c99a3b');
      gold.addColorStop(0.8, '#f6e3a1');
      gold.addColorStop(1, '#a87a25');
      ctx.fillStyle = gold;
      ctx.fillRect(0, 0, w, h);
      // Glitzer
      for (var i = 0; i < 260; i++) {
        ctx.fillStyle = Math.random() < 0.5 ? 'rgba(255,255,255,0.55)' : 'rgba(120,80,20,0.25)';
        ctx.fillRect(Math.random() * w, Math.random() * h, 1.5 * dpr, 1.5 * dpr);
      }
      // Sterne + Aufschrift
      ctx.fillStyle = 'rgba(90,60,15,0.35)';
      for (var s = 0; s < 7; s++) star(ctx, Math.random() * w, Math.random() * h, (5 + Math.random() * 6) * dpr);
      ctx.fillStyle = 'rgba(70,45,10,0.75)';
      ctx.font = '700 ' + Math.round(Math.min(w / 12, 26 * dpr)) + 'px ' + getComputedStyle(root).fontFamily;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(d.foilLabel || 'Hier rubbeln', w / 2, h / 2);
    }

    function point(event) {
      var rect = canvas.getBoundingClientRect();
      return {
        x: ((event.clientX - rect.left) / rect.width) * canvas.width,
        y: ((event.clientY - rect.top) / rect.height) * canvas.height
      };
    }

    function scratch(from, to) {
      var dpr = canvas.width / card.getBoundingClientRect().width;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 46 * dpr;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(from.x, from.y);
      ctx.lineTo(to.x, to.y);
      ctx.stroke();
      if (!checkTimer) checkTimer = setTimeout(checkProgress, 150);
    }

    // Anteil freigerubbelter Pixel (Stichprobe jedes 16. Pixels).
    function checkProgress() {
      checkTimer = null;
      if (revealed) return;
      var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var clear = 0;
      var total = 0;
      for (var i = 3; i < data.length; i += 64) {
        total++;
        if (data[i] < 32) clear++;
      }
      if (total && clear / total >= REVEAL_AT) reveal(true);
    }

    function reveal(animate) {
      if (revealed) return;
      revealed = true;
      scratching = false;
      revealLink.hidden = true;
      canvas.style.opacity = '0';
      setTimeout(function () {
        if (revealed) canvas.style.display = 'none';
      }, animate ? 450 : 0);
      if (current >= 0 && !respin) {
        try {
          localStorage.setItem(storageKey, JSON.stringify({ prize: current }));
        } catch (e) {}
      }
      showResult(animate);
    }

    function showResult(animate) {
      var dud = current < 0;
      var prize = dud ? null : prizes[current];
      result.querySelector('[data-nye-result-eyebrow]').textContent = dud ? '' : d.winEyebrow;
      result.querySelector('[data-nye-result-title]').textContent = dud ? d.dudTitle : prize.title;
      var text = dud ? d.dudText : prize.text;
      var textEl = result.querySelector('[data-nye-result-text]');
      textEl.textContent = text || '';
      textEl.hidden = !text;
      result.querySelector('[data-nye-result-fine]').innerHTML = dud ? '' : prize.fine || '';
      result.querySelector('[data-nye-code-wrap]').hidden = dud || !prize.code;
      result.querySelector('[data-nye-code]').textContent = dud ? '' : prize.code;
      result.querySelector('[data-nye-copy-hint]').textContent = 'Kopieren';
      redeem.hidden = dud || !prize.code;
      if (!dud) redeem.href = discountUrl(prize.code, prize.redirect);
      again.hidden = !(respin || dud);
      result.classList.toggle('nye__result--dud', dud);
      result.hidden = false;
      result.focus({ preventScroll: true });
      if (animate) {
        setTimeout(function () {
          result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 350);
        if (!dud) fireworks();
      }
    }

    canvas.addEventListener('pointerdown', function (event) {
      if (revealed) return;
      scratching = true;
      last = point(event);
      try {
        canvas.setPointerCapture(event.pointerId);
      } catch (e) {}
      scratch(last, { x: last.x + 0.1, y: last.y });
    });
    canvas.addEventListener('pointermove', function (event) {
      if (!scratching || revealed) return;
      var next = point(event);
      scratch(last, next);
      last = next;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
      canvas.addEventListener(type, function () {
        scratching = false;
      });
    });

    revealLink.addEventListener('click', function () {
      reveal(true);
    });

    again.addEventListener('click', function () {
      try {
        localStorage.removeItem(storageKey);
      } catch (e) {}
      newTicket();
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    result.querySelector('[data-nye-copy]').addEventListener('click', function () {
      if (current < 0) return;
      copyText(prizes[current].code).then(function () {
        result.querySelector('[data-nye-copy-hint]').textContent = 'Kopiert ✓';
      });
    });

    // Ändert sich die Kartenbreite (Drehen des Handys), wird die Folie neu gemalt.
    var lastWidth = 0;
    window.addEventListener('resize', function () {
      var width = card.getBoundingClientRect().width;
      if (!revealed && Math.abs(width - lastWidth) > 2) {
        lastWidth = width;
        paintFoil();
      }
    });

    var stored = null;
    if (!respin) {
      try {
        stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
      } catch (e) {}
    }
    if (stored && prizes[stored.prize] && phase(d) === 'active') {
      newTicket(stored.prize);
      reveal(false);
    } else {
      newTicket();
    }
    lastWidth = card.getBoundingClientRect().width;
  }

  function star(ctx, x, y, r) {
    ctx.beginPath();
    for (var i = 0; i < 10; i++) {
      var a = (Math.PI / 5) * i - Math.PI / 2;
      var rr = i % 2 ? r * 0.45 : r;
      ctx.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr);
    }
    ctx.closePath();
    ctx.fill();
  }

  function phase(d) {
    if (d.editorView) return d.editorView;
    var forced = '';
    try {
      var param = new URLSearchParams(location.search).get('rubbellos');
      if (param === 'aus') sessionStorage.removeItem('pny-nye-preview');
      else if (param === 'an') sessionStorage.setItem('pny-nye-preview', 'an');
      forced = sessionStorage.getItem('pny-nye-preview') || '';
    } catch (e) {}
    if (forced) return 'active';
    var today;
    try {
      today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Berlin' }).format(new Date());
    } catch (e) {
      today = new Date().toISOString().slice(0, 10);
    }
    var iso = /^\d{4}-\d{2}-\d{2}$/;
    if (iso.test(d.start) && today < d.start) return 'before';
    if (iso.test(d.end) && today > d.end) return 'after';
    return 'active';
  }

  function showView(root, name) {
    root.querySelectorAll('[data-nye-view]').forEach(function (view) {
      view.hidden = view.dataset.nyeView !== name;
    });
  }

  // Niete mit festem Anteil, sonst Gewinn nach Gewichtung (alle 0 = gleich oft).
  function draw(prizes, dudPercent) {
    if (dudPercent > 0 && Math.random() * 100 < dudPercent) return -1;
    var total = prizes.reduce(function (sum, p) {
      return sum + Math.max(0, Number(p.weight) || 0);
    }, 0);
    if (!total) return (Math.random() * prizes.length) | 0;
    var r = Math.random() * total;
    for (var i = 0; i < prizes.length; i++) {
      r -= Math.max(0, Number(prizes[i].weight) || 0);
      if (r < 0) return i;
    }
    return prizes.length - 1;
  }

  function discountUrl(code, redirect) {
    var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var target = redirect || shopRoot + 'collections/all';
    return shopRoot + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    var area = document.createElement('textarea');
    area.value = text;
    area.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    area.remove();
    return Promise.resolve();
  }

  // Feuerwerk: mehrere Explosionen in Gold und Weiß nacheinander.
  function fireworks() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#f5e3a3', '#ffffff', '#d4af5a', '#fff6dc', '#c99a3b'];
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = (canvas.width = window.innerWidth * dpr);
    var h = (canvas.height = window.innerHeight * dpr);
    var sparks = [];
    function explode(x, y, color) {
      for (var i = 0; i < 70; i++) {
        var a = Math.random() * Math.PI * 2;
        var speed = (2 + Math.random() * 5) * dpr;
        sparks.push({ x: x, y: y, vx: Math.cos(a) * speed, vy: Math.sin(a) * speed, life: 1, color: color });
      }
    }
    [0, 350, 700, 1050].forEach(function (delay, i) {
      setTimeout(function () {
        explode(w * (0.2 + Math.random() * 0.6), h * (0.15 + Math.random() * 0.35), colors[i % colors.length]);
      }, delay);
    });
    var start = performance.now();
    function frame(now) {
      ctx.clearRect(0, 0, w, h);
      sparks.forEach(function (p) {
        p.vy += 0.06 * dpr;
        p.vx *= 0.98;
        p.vy *= 0.98;
        p.x += p.vx;
        p.y += p.vy;
        p.life -= 0.012;
        if (p.life <= 0) return;
        ctx.globalAlpha = p.life;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, 2.2 * dpr, 0, Math.PI * 2);
        ctx.fill();
      });
      if (now - start < 3200) requestAnimationFrame(frame);
      else canvas.remove();
    }
    requestAnimationFrame(frame);
  }

  function boot() {
    document.querySelectorAll('[data-nye]').forEach(function (root) {
      if (root.dataset.nyeReady) return;
      root.dataset.nyeReady = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
